import React, { CSSProperties } from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

type InterpreterInfoTooltipProps = {
  id: string
  text: string
}

const tooltipStyle: CSSProperties = {
  '--bs-tooltip-bg': '#ffffff',
  '--bs-tooltip-color': '#a3a242',
  '--bs-tooltip-opacity': '1',
  '--bs-tooltip-max-width': '280px',
  '--bs-tooltip-padding-x': '10px',
  '--bs-tooltip-padding-y': '8px',
  '--bs-tooltip-border-radius': '12px',
  '--bs-tooltip-font-size': '14px',
  fontFamily: "'Lexend', sans-serif",
} as CSSProperties

export function InterpreterInfoTooltip({ id, text }: InterpreterInfoTooltipProps) {
  return (
    <OverlayTrigger
      placement='top'
      trigger={['hover', 'focus']}
      overlay={
        <Tooltip id={id} style={tooltipStyle}>
          <span style={{ display: 'block', maxWidth: 240, lineHeight: 1.45, textAlign: 'left' }}>{text}</span>
        </Tooltip>
      }
    >
      <button
        type='button'
        aria-label='More information'
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 15,
          height: 15,
          borderRadius: '50%',
          border: '2px solid #a3a242',
          backgroundColor: '#ffffff',
          color: '#a3a242',
          fontSize: 10,
          fontWeight: 700,
          lineHeight: 1,
          padding: 0,
          cursor: 'pointer',
          flexShrink: 0,
        }}
      >
        i
      </button>
    </OverlayTrigger>
  )
}
